import { myFetch, HttpMethod } from './baseService';

// ==================== INTERFACES ====================

export interface DiaUtilizacion {
  ddu_codigo: string;
  ddu_nombre: string;
}

export interface InsertarHorarioZonaComunRequest {
  "zona comun codigo": string;
  "dia de utilizacion codigo": string;
  "hora apertura": string;
  "hora cierre": string;
}

export interface HorarioZonaComun {
  zhd_codigo: number;
  zhd_zona_comun: string;
  zhd_dia_de_utilizacion: string;
  zhd_hora_apertura: string;
  zhd_hora_cierre: string;
}

export interface ObtenerHorariosZonaComunRequest {
  codigo: string;
  "zona comun codigo": string;
  "dia de utilizacion codigo": string;
}

export interface ModificarHorarioZonaComunRequest {
  codigo: number;
  "zona comun codigo": string;
  "hora apertura": string;
  "hora cierre": string;
}

export interface ApiEnvelope<T> {
  code: string | number;
  message: string;
  object_: T;
}

// ==================== FUNCIONES API ====================

/**
 * Obtener todos los días de utilización
 */
export const obtenerTodosDiasUtilizacion = async (): Promise<ApiEnvelope<DiaUtilizacion[]>> => {
  const envelope = await myFetch<ApiEnvelope<DiaUtilizacion[]>>(
    'dia_de_utilizacion/ObtenerTodos',
    HttpMethod.POST,
    {}
  );
  return envelope;
};

/**
 * Insertar horario de zona común por día
 */
export const insertarHorarioZonaComun = async (
  payload: InsertarHorarioZonaComunRequest
): Promise<ApiEnvelope<HorarioZonaComun[]>> => {
  const envelope = await myFetch<ApiEnvelope<HorarioZonaComun[]>>(
    'zona_comun_horario_por_dia/Insertar',
    HttpMethod.POST,
    payload
  );
  return envelope;
};

/**
 * Obtener todos los horarios de zona común por día
 */
export const obtenerHorariosZonaComun = async (
  payload: ObtenerHorariosZonaComunRequest
): Promise<ApiEnvelope<HorarioZonaComun[]>> => {
  const envelope = await myFetch<ApiEnvelope<HorarioZonaComun[]>>(
    'zona_comun_horario_por_dia/ObtenerTodo',
    HttpMethod.POST,
    payload
  );
  return envelope;
};

/**
 * Modificar horario de zona común por día
 */
export const modificarHorarioZonaComun = async (
  payload: ModificarHorarioZonaComunRequest
): Promise<ApiEnvelope<HorarioZonaComun[]>> => {
  const envelope = await myFetch<ApiEnvelope<HorarioZonaComun[]>>(
    'zona_comun_horario_por_dia/Modificar',
    HttpMethod.POST,
    payload
  );
  return envelope;
};

